import { render, staticRenderFns } from "./newSkuList.vue?vue&type=template&id=96571f88"
import script from "./newSkuList.vue?vue&type=script&lang=js"
export * from "./newSkuList.vue?vue&type=script&lang=js"
import style0 from "./newSkuList.vue?vue&type=style&index=0&id=96571f88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports